<template>
    <div :class="getCss('bind-phone-main')">
      <div :class="getCss('bind-phone-container')">
<!--     begin 首次绑定手机手机-->
       <div  v-if="isAlreadyBindPhone=== false" :class="getCss('do-bind-phone-area')">
         <!--         输入手机号 -->
         <div :class="getCss('bind-item')">
           <input placeholder="请输入手机号" v-model="phone" type="number"
                  oninput="if(value.length > 11)value = value.slice(0, 11)"
                  :class="getCss(['input','input-phone'])"
                  :style="inputStyle">
         </div>
<!--         输入验证码 -->
         <div :class="getCss('bind-item')">
           <input placeholder="请输入验证码" v-model="verificationCode"
                  type="number" oninput="if(value.length > 6)value = value.slice(0, 6)"
                  :class="getCss(['input','input-code','input-width'])"
                  :style="inputStyle">
           <div v-if="!timer"  @click="sendVerifyCode" :class="getCss(['click-btn-active','click-btn'])"
           :style="textFontStyle">
              获取验证码
           </div>
           <div  v-if="timer"  :class="getCss(['click-btn'])" :style="textFontStyle">
             剩余{{countDownSecond}}秒
           </div>
         </div>

          <div @click="bindPhone"
           :class="getCss('bind-item-btn')"
          :style="textFontStyle">
                 确定绑定
          </div>
       </div>
<!--   end    首次绑定手机手机-->
<!-- begin 解除绑定手机和更换绑定手机-->
      <div v-if="isAlreadyBindPhone===true "
           :class="getCss('do-cancel-phone-area')">
        <p :class="getCss('done-bind-phone-title')"
        :style="headStyle">
          您的手机号
        </p>
        <p :style="headStyle" :class="getCss('done-bind-phone-encrypt')">
           {{ encryptedPhone }}
        </p>
        <div :class="getCss('action-item-btn')"
         :style="textFontStyle"
         @click="showChangeBindPhone= true">
          更换绑定手机
        </div>
        <p :class="getCss('cancel-bind-btn')" @click="showCancelPhone=true" :style="relieve" >
            解除绑定
        </p>
      </div>
<!--end 解除绑定手机和更换绑定手机-->

      </div>

      <!--begin 重新绑定手机-->
      <cBaseDialogTemplate
          v-model="showChangeBindPhone"
          @close="showChangeBindPhone=false;reset();"
          :configurationData="configurationData"
      >
        <template slot="exchange-bind-phone">
          <!--         更换手机 输入手机号 -->
          <div>

            <div  :class="getCss('bind-action-phone-title')" :style="headStyle">更换绑定手机号</div>
            <!--         输入手机号 -->
            <div :class="getCss('bind-action-pop-area')">
              <div :class="getCss('bind-item')">
                <input placeholder="请输入手机号" v-model="phone" type="number"
                       oninput="if(value.length > 11)value = value.slice(0, 11)"
                       :class="getCss(['input','input-phone'])"
                       :style="inputStyle">
              </div>
              <!--         输入验证码 -->
              <div :class="getCss(['bind-item','bind-item-mage'])">
                <input placeholder="请输入验证码" v-model="verificationCode"
                        :style="inputStyle"
                       oninput="if(value.length > 6)value = value.slice(0, 6)"
                       type="number" :class="getCss(['input','input-code','input-width'])">
                <div v-if="!timer"  @click="sendVerifyCode"
                :style="textFontStyle" :class="getCss(['click-btn-active','click-btn'])">
                  获取验证码
                </div>
                <div  v-if="timer"  :class="getCss(['click-btn'])"
                :style="textFontStyle">
                  剩余{{countDownSecond}}
                </div>
              </div>

              <div :class="getCss('action-item-btn')" @click="exchangeBindPhone"
               :style="textFontStyle">
                确定更换
              </div>

            </div>


          </div>

        </template>


      </cBaseDialogTemplate>

<!--      解除绑定手机-->
      <cBaseDialogTemplate
          v-model="showCancelPhone"
          @close="showCancelPhone=false;reset();"
          :configurationData="configurationData"
      >
        <template slot="cancel-bind-phone">
          <div>

            <p  :class="getCss('bind-action-phone-title')" :style="headStyle">解除手机号绑定</p>

            <div :class="getCss('bind-action-pop-area')">
            <p :class="getCss('bind-encrypted-phone')" :style="showTextStyle">{{encryptedPhone}}</p>
            <div :class="getCss(['bind-item','bind-item-mage'])">
              <input placeholder="请输入验证码" v-model="verificationCode"
                    :style="inputStyle"
                     oninput="if(value.length > 6)value = value.slice(0, 6)"
                     type="number" :class="getCss(['input','input-code','input-width'])">
              <div v-if="!timer"  @click="sendVerifyCode('cancel')"
                    :style="textFontStyle"
                   :class="getCss(['click-btn-active','click-btn'])">
                获取验证码
              </div>
              <div  v-if="timer"  :class="getCss(['click-btn'])" :style="textFontStyle">
                剩余{{countDownSecond}}
              </div>
            </div>

            <div :class="getCss('action-item-btn')" @click="cancelBindPhone"
               :style="textFontStyle">
              确定解绑
            </div>

            </div>
          </div>

        </template>
      </cBaseDialogTemplate>

    </div>
</template>

<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';
import cBaseDialogTemplate from './c-base-dialog-template.vue';

export default {
  name: 'BindPhonePc',
  components: {
    [CDialog.name]: CDialog,
    cBaseDialogTemplate,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'bind-phone-pc-',
      isCheckUserContract: false, //  是否已经点击的用户
      showCancelPhone: false,
      showChangeBindPhone: false,
      verificationCode: '', // 验证码
      phone: '', //  输入手机号
      encryptedPhone: '', // 脱敏的手机号
      isAlreadyBindPhone: false, // 是否已经绑定手机
      countDownSecond: 60, // 倒计时
      timer: null, // 倒计时
      errorMsg: '请先登录',
      phoneRecordItem: {},
    };
  },
  computed: {
    // 发送验证码
    sendVerifyCodeFlowId() {
      return this.configurationData.sendVerifyCodeFlowId;
    },
    // 绑定|解绑|解除 手机流程
    bindExchangeCancelPhoneFlowId() {
      return this.configurationData.bindPhoneFlowId;
    },
    // 查询用户手机号
    queryPhoneFlowId() {
      return this.configurationData.queryPhoneFlowId;
    },
    gid() {
      return this.actInfo?.gid || 0;
    },
    forceRole() { // 是否需要角色绑定
      return this.configurationData.forceRole;
    },
    textFontStyle() { // 按钮样式
      return {
        fontSize: this.configurationData.tetxFontSize,
        color: this.configurationData.butColor,
        height: this.configurationData.inputHeight,
        backgroundColor: this.configurationData.TextBgColor,
        borderColor: this.configurationData.BoderColor,
      };
    },
    inputStyle() { // 输入框样式
      return {
        color: this.configurationData.inputColor,
        height: this.configurationData.inputHeight,
        fontSize: this.configurationData.tetxFontSize,
        backgroundColor: this.configurationData.inputBgColor,
        borderColor: this.configurationData.BoderColor,
      };
    },
    relieve() { // 解除绑定按钮
      return {
        color: this.configurationData.butColor,
        fontSize: this.configurationData.tetxFontSize,
      };
    },
    headStyle() { // 标题样式
      return {
        height: this.configurationData.headHeight,
        color: this.configurationData.butColor,
      };
    },
    showTextStyle() {
      return {
        fontSize: this.configurationData.tetxFontSize,
        height: this.configurationData.inputHeight,
        color: this.configurationData.inputColor,
      };
    },
  },
  async mounted() {
    await this.initialize();
    // 点击同意授权获取的状态
    this.$eventBus.$on('ceiba:custom:events:SyncUserContractStatus', ({ status }) => {
      if (status) {
        this.isCheckUserContract = true;
      } else {
        this.isCheckUserContract = false ;
      }
    });
  },
  destroyed() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  },
  methods: {
    checkIsAgreeUserContract() {
      if (this.isCheckUserContract === false) {
        this.errorMsg = '请同意上述收集手机号协议内容';
        this.$alert(this.errorMsg);
        return  false;
      }
      return true;
    },
    checkHasRole() {
      if (!this.roleInfo.role_id && this.forceRole) {
        this.errorMsg = '请先绑定角色!';
        this.$alert(this.errorMsg);
        return false;
      }
      return  true;
    },
    checkHasAuth() {
      if (!this.isLogin) {
        this.errorMsg = '请先登录!';
        this.$alert(this.errorMsg);
        return false;
      }
      return  true;
    },
    checkPhoneFormat(phone) {
      const tempPhone = phone ? phone : this.phone;
      if (!(/^1[3456789]\d{9}$/.test(tempPhone))) {
        this.$alert({ msg: '请填写正确手机号' });
        return false;
      }
      return true;
    },
    checkPhoneEmpty(phone) {
      const tempPhone = phone ? phone : this.phone;
      if (!tempPhone) {
        this.showToast('请输入手机号');
        return false;
      }
      return  true;
    },
    checkVerifyCodeEmpty() {
      if (!this.verificationCode) {
        this.showToast('请输入验证码');
        return false;
      }
      return  true;
    },
    // 重新绑定解绑手机
    async exchangeBindPhone() {
      if (this.phone.length < 11 || this.verificationCode.length < 6) {
        return  false;
      }
      this.handleClickEvent();
      if (!this.checkPhoneEmpty()) {
        return  false;
      }
      if (!this.checkPhoneFormat()) {
        return  false;
      }
      if (!this.checkVerifyCodeEmpty()) {
        return  false;
      }

      const  res = await  this.flowRequest({
        flowId: this.bindExchangeCancelPhoneFlowId,
        params: {
          data: JSON.stringify({
            phone: this.phone,
            channel: 3,
            gid: this.gid,
            // 用户是否授权 0=已授权，1=未授权，默认0
            userAuthorize: 1,
            operator: 0,
            verifyCode: this.verificationCode,
          }),
        } });
      const { data = {}, msg: retMsg, ret: resRet } = res;
      if (resRet !== 0 && retMsg) {
        this.showAlertMsg(retMsg);
        this.reportFunc('bind_phone', { status: '0' });
        return false;
      }
      const { ret, msg  } = data || {};

      if (ret !== 0) {
        this.showAlertMsg(msg || '操作失败');
        this.reportFunc('bind_phone', { status: '0' });
        return false;
      }
      this.showToast('更换绑定成功');
      this.initQueryPhone();
      this.showChangeBindPhone = false;
      this.reset();
      this.resetCountDown();
      this.reportFunc('bind_phone', { status: '1' });
    },
    // 解绑手机
    async cancelBindPhone() {
      if (this.verificationCode.length <  6) {
        return  false;
      }
      this.handleClickEvent();
      if (!this.checkVerifyCodeEmpty()) {
        return  false;
      }
      const { phone = '' }  = this.phoneRecordItem;
      if (!phone) {
        return  this.showAlertMsg('操作异常,暂无绑定手机记录');
      }
      // 用户是否授权 0=已授权，1=未授权，默认0
      const requestData = {
        phone,
        channel: 3,
        gid: this.gid,
        // 用户是否授权 0=已授权，1=未授权，默认0
        userAuthorize: 0,
        operator: 0,
        verifyCode: this.verificationCode,
      };
      const res   = await  this.flowRequest({
        flowId: this.bindExchangeCancelPhoneFlowId,
        params: {
          data: JSON.stringify(requestData),
        } });
      const { data = {}, msg: retMsg, ret: resRet } = res;
      if (resRet !== 0 && retMsg) {
        this.showAlertMsg(retMsg);
        this.reportFunc('unbind_phone', { status: '0' });
        return false;
      }
      const  { ret, msg } = data || {};

      if (ret !== 0) {
        this.showAlertMsg(msg || '操作失败');
        this.reportFunc('unbind_phone', { status: '0' });
        return true;
      }
      this.showToast('解绑成功');
      this.initQueryPhone();
      this.reset();
      this.showCancelPhone = false;
      this.resetCountDown();
      this.reportFunc('unbind_phone', { status: '1' });
    },

    // 发送验证码
    async sendVerifyCode(type) {
      this.handleClickEvent();
      if (!this.checkHasAuth()) {
        return  false;
      }
      if (!this.checkHasRole()) {
        return  false;
      }
      // 已经发送
      if (this.timer) {
        return false;
      }
      let  targetPhone = '';
      if (type === 'cancel') {
        const { phone } = this.phoneRecordItem;
        targetPhone = phone;
        if (!this.checkPhoneEmpty(phone)) {
          return  false;
        }
      } else {
        targetPhone = this.phone;
        if (!this.checkPhoneEmpty()) {
          return  false;
        }
        if (!this.checkPhoneFormat()) {
          return  false;
        }
      }
      // 获取phone
      let res = {};
      res = await this.flowRequest({
        flowId: this.sendVerifyCodeFlowId,
        params: {
          data: JSON.stringify({ phone: targetPhone }),
        } });

      const { data = {}, msg: retMsg, ret: resRet } = res;
      // 其他流程错误返回
      if (resRet !== 0 && retMsg) {
        this.showAlertMsg(retMsg);
        return false;
      }
      let  sendRes  = -1 ;
      const { ret, msg, value = 0 } = data || {};
      sendRes = ret;
      if (type === 'cancel' && (value === 10016 || value === 10017)) {
        // 对于用户来说是透明
        // 重新获取
        const { data = {}, ret: resRet } = await this.getPurePhone();
        if (resRet === 0 && data) {
          const { ret, mask, userAuthorize, phone } = data || {};
          if (userAuthorize === 1) {
            this.phoneRecordItem = {
              ret,
              mask,
              userAuthorize,
              phone,
            };
            this.flowRequest({
              flowId: this.sendVerifyCodeFlowId,
              params: {
                data: JSON.stringify({ phone }),
              } });
            sendRes = 0;
          }
        }
      }
      if (sendRes === 0) {
        this.countDown();
        this.showToast('验证码已发送');
        this.reportFunc('get_verifycode', { status: '1', type: 'phone' });
        return;
      }
      this.showAlertMsg(msg || '获取验证码失败');
      this.reportFunc('get_verifycode', { status: '0', type: 'phone' });
    },
    // 绑定手机
    async bindPhone() {
      if (this.phone.length < 11 || this.verificationCode.length < 6) {
        return  false;
      }
      this.handleClickEvent();
      if (!this.checkHasAuth()) {
        return  false;
      }
      if (!this.checkHasRole()) {
        return  false;
      }
      if (!this.checkIsAgreeUserContract()) {
        return false;
      }

      if (!this.checkPhoneEmpty()) {
        return  false;
      }
      if (!this.checkPhoneFormat()) {
        return  false;
      }
      if (!this.checkVerifyCodeEmpty()) {
        return  false;
      }
      const  res = await  this.flowRequest({
        flowId: this.bindExchangeCancelPhoneFlowId,
        params: {
          data: JSON.stringify({
            phone: this.phone,
            channel: 3,
            gid: this.gid,
            userAuthorize: 1,
            operator: 0,
            verifyCode: this.verificationCode,
          }),
        } });
      const { data = {}, msg: retMsg, ret: resRet } = res;
      if (resRet !== 0 && retMsg) {
        this.showAlertMsg(retMsg);
        this.reportFunc('bind_phone', { status: '0' });
        return false;
      }
      const { ret, msg } = data || {};

      if (ret !== 0) {
        this.showAlertMsg(msg || '操作失败');
        this.reportFunc('bind_phone', { status: '0' });
        return false;
      }
      this.showToast('绑定成功');
      this.initQueryPhone();
      this.reset();
      this.resetCountDown();
      this.reportFunc('bind_phone', { status: '1' });
    },

    // 获取验证码倒计时
    resetCountDown() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = null;
      this.countDownSecond = 60;
    },
    reset() {
      this.phone = '';
      this.verificationCode = '';
    },
    countDown() {
      if (this.timer) {
        return false;
      }
      this.timer = setInterval(() => {
        if (this.countDownSecond <= 0) {
          this.countDownSecond = 60;
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.countDownSecond = this.countDownSecond - 1;
      }, 1000);
    },
    async getPurePhone() {
      const requestData = {
        channel: 3,
        gid: this.gid,
      };
      const res = await this.flowRequest({
        flowId: this.queryPhoneFlowId,
        params: {
          data: JSON.stringify(requestData),
        } });
      return new Promise(resolve => resolve(res));
    },
    async initQueryPhone() {
      const requestData = {
        channel: 3,
        gid: this.gid,
      };
      // 获取phone
      try {
        const res = await this.flowRequest({
          flowId: this.queryPhoneFlowId,
          params: {
            data: JSON.stringify(requestData),
          } });
        const { data = {}, msg, ret: resRet } = res;
        if (resRet !== 0 && msg) {
          this.showAlertMsg(msg);
          return false;
        }

        const { ret, mask = '', userAuthorize = '', phone = '' }  = data || {};
        if (ret !== 0) {
          return false;
        }
        if (userAuthorize === 1 && mask) {
          // 已经 绑定手机
          this.encryptedPhone = mask;
          this.isAlreadyBindPhone = true;
          this.phoneRecordItem = {
            ret,
            mask,
            userAuthorize,
            phone,
          };
          this.$eventBus.$emit('ceiba:custom:events:CheckUserContractStatus', { status: true });
        } else {
          this.$eventBus.$emit('ceiba:custom:events:CheckUserContractStatus', { status: false });
          this.encryptedPhone = '';
          this.isAlreadyBindPhone = false;
          this.phoneRecordItem = {};
        }
      } catch (e) {
        const { ret = -1, msg  } = (e?.data) || {};
        if (ret !== 0 && msg) {
          this.showAlertMsg(msg);
          return false;
        }
      }
    },
    async initialize() {
      this.$onLogined(async () => {
        this.initQueryPhone();
      });
    },
    reportFunc(key, obj) {
      if (typeof  this.reportClickRaw === 'function') {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: key,
          eventData: obj || {},
        };
        this.reportClickRaw(params);
      }
    },
    showAlertMsg(msg) {
      this.$alert({
        msg: `${msg || '操作失败'}`,
      });
    },
    showToast(msg) {
      this.$toast(`${msg || '操作失败'}`, 3000);
    },
  },
};
</script>

<style lang="scss">
@import './bind-phone-pc.scss';

input[type='number'] {
  appearance: textfield;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  appearance: none;
  margin: 0;
}
</style>
